export function getTimeRemaining(startDate: string, endDate: string) {
  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();
  const now = Date.now();

  const diffFromNow = end - now;
  const totalDuration = end - start;

  // If the date is already over
  if (diffFromNow <= 0) {
    return {
      status: "ended",
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      totalDuration,
      isExpired: true,
    };
  }

  const days = Math.floor(diffFromNow / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (diffFromNow % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((diffFromNow % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diffFromNow % (1000 * 60)) / 1000);

  return {
    status: "ongoing",
    days,
    hours,
    minutes,
    seconds,
    totalDuration,
    isExpired: false,
  };
}

// export function getTimeRemaining(startDate: string, endDate: string) {
//   const start = new Date(startDate).getTime();
//   const end = new Date(endDate).getTime();
//   const now = Date.now();

//   // If you want time remaining from now until end
//   const diffFromNow = end - now;
//   console.log(diffFromNow);

//   // If you want total duration between start and end
//   const totalDuration = end - start;

//   // Convert to days, hours, minutes, seconds
//   const days = Math.floor(diffFromNow / (1000 * 60 * 60 * 24));
//   const hours = Math.floor(
//     (diffFromNow % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
//   );
//   const minutes = Math.floor((diffFromNow % (1000 * 60 * 60)) / (1000 * 60));
//   const seconds = Math.floor((diffFromNow % (1000 * 60)) / 1000);

//   return {
//     days,
//     hours,
//     minutes,
//     seconds,
//     totalDuration, // in milliseconds
//     isExpired: diffFromNow <= 0,
//   };
// }
